/*
 * @Author: Hyman Choi
 * @Date: 2021-01-21 15:24:29
 * @LastEditTime: 2021-01-29 14:41:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\api\user.js
 */
import request from '@/utils/request'
import config from '@/utils/config'

/**
 * 用户登录
 *
 * @param {*} params
 */
export function login(params) {
  return request({
    url: config.API_AUTH + '/auth/v1/login',
    method: 'get',
    params
  })
}

/**
 * 获取用户信息
 *
 * @param {*} params
 */
export function getInfo(params) {
  return request({
    url: config.API_AUTH + '/auth/v1/user',
    method: 'get',
    params
  })
}

export function logout() {
  return request({
    url: config.API_MEDICAL + '/Api/V1/Users/Logout',
    method: 'post'
  })
}
